const API = {
  GET_REVIEWS: {
    path: '/review/expert',
    method: 'GET',
  },

};
export default API;
